import workspaceTrendsUi from './workspace-trends-ui'

export default {
    confirm: {
        title: 'Macro trend selection',
        notice: 'Would you now like to select all macro trends from the "{title}" workspace for trend evaluation?',
        confirm: 'Yes, select macro trends'
    },

    workspaceTrendsUi
}
